<template>
  <OmtLayoutContainer>
    <OmtRow border-radius="8px" padding="16px" bg="var(--colors-light-primary-light-gray)" flex-direction="column">
      <CFlex class="row-center">
        <i class="icon fas fa-exclamation-circle" />
        <OmtTypography as="h2-bold" color="var(--colors-light-primary-gray)" ml="12px"> Atenção </OmtTypography>
      </CFlex>
      <OmtRow mt="12px" class="row-column">
        <OmtTypography as="p1-bold" mb="8px" color="var(--colors-light-primary-gray)">
          Use esta opção somente para dúvidas e informações gerais
        </OmtTypography>
        <OmtTypography as="p1" mb="12px" color="var(--colors-light-primary-gray">
          como fatura, contrato, acompanhamento de reclamações feitas por telefone ou e-mail entre outros.
        </OmtTypography>

        <OmtTypography as="p1-bold" mb="8px" color="var(--colors-light-primary-gray)"> Importante: </OmtTypography>
        <OmtTypography as="p1" mb="12px" color="var(--colors-light-primary-gray)">
          Não utilize esta opção para registrar reclamações ou enviar solicitações que já estão disponíveis no app, como
          reembolso, orçamento, autorização, indicação de rede ou análise de cobertura.
        </OmtTypography>

        <OmtTypography as="p1-bold" mb="8px" color="var(--colors-light-primary-gray)">
          Precisa de ajuda?
        </OmtTypography>
        <OmtTypography as="p1" color="var(--colors-light-primary-gray)">
          Entre em contato com a nossa Central de Atendimento pelo <span class="phone"> 0800 726 4000</span> ou via
          WhatsApp.
        </OmtTypography>
      </OmtRow>
    </OmtRow>

    <OmtRow mt="48px" justifyContent="center">
      <CStack :align="'center'">
        <OmtButton :w="['100%', '342px !important']" @click="goToNextPage">Continuar</OmtButton>
      </CStack>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "ProgramasSaudeTerm",
  methods: {
    ...mapMutations("programasSaude", ["SET_NEW_SOLICITATION"]),
    goToNextPage() {
      this.SET_NEW_SOLICITATION({ aceiteTermo: true });
      this.$router.push({ name: "programas-saude-revision" });
    }
  },
  async mounted() {
    this.$root.$emit("hide-loading");
  }
};
</script>

<style scoped>
.row-center {
  display: flex;
  align-items: center;
}
.row-column {
  display: flex;
  flex-direction: column;
}
.phone {
  font-weight: 700;
}
</style>
